import { useEffect, useState } from 'react';
import { Box, Flex, Divider } from "@chakra-ui/react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { getZoomOauthRedirectUri, revokeOauth } from '../../../organizations/actions/external-integration-actions';
import { SiZoom } from "react-icons/si";


function ExternalIntegrationsModule({
	//Parent Component
	// Actions
	revokeOauth,
	getZoomOauthRedirectUri,
	//Redux States
	authorisedExternalIntegrations,
}) {

	const [showLoadingState, setShowLoadingState] = useState(false)
	const { authorisedZoom } = authorisedExternalIntegrations || {}

	const handleClickConnectButton = () => {
		setShowLoadingState(true)
		getZoomOauthRedirectUri()
	}

	const handleClickDisconnectButton = (serviceProviderName) => {
		setShowLoadingState(true)
		serviceProviderName && revokeOauth({ serviceProviderName })
	}

	useEffect(() => {
		if (authorisedExternalIntegrations) {
			setShowLoadingState(false)
		}
	}, [authorisedExternalIntegrations]);

	return (
		<Flex w='100%' direction='column'>

			<Flex w='100%' justify='space-between' alignItems={['flex-start', 'center', 'center', 'center']}>
				<Box className="user-profile-section__first-label"> Integrations </Box>
			</Flex>

			<Divider />

			<Box mt='2em'>
				<Flex p='1em' border='1px solid' color='gray.300' rounded='0.25em' w='100%' gap={2} justify='space-between' align='center'>
					<Flex justify='flex-start' align='center' gap={8}>
						<Box as={SiZoom} boxSize="3em" color="brandDark.500" />
						<Box color='gray.500' fontSize='0.75em'>{authorisedZoom ? 'Status: LIVE' : 'Create & let your audience join Zoom calls seamlessly inside your Rooms, all in one place'} </Box>
					</Flex>

					<Box>
						{authorisedZoom ?
							<LaunchdeckButton bg='brandPink.500' color='white' fontSize='0.8em' loadingLogic={showLoadingState} onClick={() => handleClickDisconnectButton('zoom')} label='Disconnect' />
							:
							<LaunchdeckButton bg='brand.500' color='white' fontSize='0.8em' loadingLogic={showLoadingState} onClick={() => handleClickConnectButton()} label='Connect' />
						}
					</Box>

				</Flex>
			</Box>

		</Flex>
	)
}


function mapStateToProps(state) {
	return {
		authorisedExternalIntegrations: state.authorisedExternalIntegrationsConfig.results
	};
}


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getZoomOauthRedirectUri,
			revokeOauth
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExternalIntegrationsModule));